import {ES, LS, SS} from '@services/ls';
import {_CONST} from '@/constants/constants';
import {RoutesList} from '@/interfaces/interfaces';

export default function guest ({ next, store, to, from }){
    const user = store.getters['main/getUser'];

    const route = {
        fullPath: to.fullPath,
        hash: to.hash,
        name: to.name,
        params: to.params,
        path: to.path,
        query: to.query,
        meta: to.meta,
    }
    // if (to.name !== RoutesList.auth && !user.loggedIn) SS.set(_CONST.lsKeys.prevRoute, route)

    const accessToken = ES.get(_CONST.lsKeys.accessToken)
    const refreshToken = ES.get(_CONST.lsKeys.refreshToken)
    console.info('>> guest', user.loggedIn, SS.get(_CONST.lsKeys.prevRoute), route, !!accessToken, !!refreshToken, from)
    if (!!accessToken && !!refreshToken) {
        return next({
            name: RoutesList.preloader
        });
    }

    return next();
}
